import * as React from "react";
import { forwardRef } from "react";
const SvgMenu = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", fill: "none", ref, ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20 8H4V6H20V8ZM20 13H4V11H20V13ZM4 18H20V16H4V18Z", fill: "currentcolor" }));
const ForwardRef = forwardRef(SvgMenu);
export default ForwardRef;
